import React from 'react'
import "./headingtable.scss"
 const HeadingTable = (props) => {
  return (
   <h1  className={`tablePageHeading  ${props.className}`} > {props.Heading} </h1>
  )
}
export default HeadingTable;